
import React, { useState, useEffect } from "react";
import PDF from '../DiegoTeran.pdf';
import Bounce from 'react-reveal/Bounce';
import firebaseDb from "../firebase";
import {  ref, child, get} from "firebase/database";
import Loading from "../images/loading2.gif";




const About = () => {

    const [contactObjects, setContactObjects] = useState({}) 
     const dbRef = ref(firebaseDb);
     const [isLoading, setLoading] = useState(true)

    useEffect(() => {
        get(child(dbRef,'sobremi')).then((snapshot) => {
            if (snapshot.exists()) {
           
             
              setContactObjects({
                ...snapshot.val()
            })
  
            setLoading(false) 
           
          
             //console.log(snapshot.val());
            } else {
              setContactObjects({})
              console.log("No data available");
            }
          }).catch((error) => {
            console.error(error);
          });
  }, []);
  



    return (
        <>
 <Bounce left>
            <div className="container mt-5">
         
                <section className="about">

                    <h1 className="heading"> Sobre <span>mim</span> </h1>

                    <div className="row">

                        <div className="info-container">
                
                            <h1>Informações Pessoais</h1>

                            <div className="box-container">

                            <div className="box">
                                    <h3><span>Nome : </span>Diego Teran</h3>
                                    <h3><span>Idade: </span>33</h3>
                                    <h3><span>email : </span>diegoteran4@gmail.com</h3>
                                    <h3><span>Endereço : </span>São Paulo - Brasil</h3>
                                </div>

                                <div className="box">
                                    <h3><span>Livreção : </span> Disponível</h3>
                                    <h3><span>Skill : suporte </span>TI</h3>
                                    <h3><span>Experiência : </span>3 anos</h3>
                                    <h3><span>Languagens: </span>Espanhol, Português</h3>
                                </div>

                            </div>
              
                            <a href={PDF} className="btn" download="Diego-Teran.pdf"> Baixe meu CV <i className="fas fa-download"></i> </a>

                        </div>

                        <div className="count-container">

                            <div className="box">
                                <h3>4+</h3>
                                <p>Anos de experiência</p>
                            </div>

                            <div className="box">
                                <h3>6+</h3>
                                <p>Empresas</p>
                            </div>

                            <div className="box">
                                <h3>3+</h3>
                                <p>Como esp. Tecnología
                                </p>
                            </div>

                            <div className="box">
                                <h3>1+</h3>
                                <p>Front End</p>
                            </div>

                        </div>

                    </div>

                </section>
        

                
                <section className="skills">

                    <h1 className="heading"> <span>Minhas </span> Habilidades </h1>

                    <div className="box-container">
                        <div className="box">

                        {isLoading 
                          ? 
                          <div className="image">
                          
                            <img src={Loading} alt="img"/>
                          </div>
                          : (
                                
                            <div>
                            {Object.keys(contactObjects).map((key) => {
                                return (
                                      <img src={contactObjects[key].icon1} alt=""/>
                                    );
                                  })}
                           
                            </div>
                            )
                          }
                            
                            <h3>html</h3>
                        </div>
                        <div className="box">
                        {isLoading 
                          ? 
                          <div className="image">
                          
                            <img src={Loading} alt="img"/>
                          </div>
                          : (
                                
                            <div>
                            {Object.keys(contactObjects).map((key) => {
                                return (
                                      <img src={contactObjects[key].icon2} alt=""/>
                                    );
                                  })}
                           
                            </div>
                            )
                          }
                            <h3>css</h3>
                        </div>
                        <div className="box">
                        {isLoading 
                          ? 
                          <div className="image">
                          
                            <img src={Loading} alt="img"/>
                          </div>
                          : (
                                
                            <div>
                            {Object.keys(contactObjects).map((key) => {
                                return (
                                      <img src={contactObjects[key].icon3} alt=""/>
                                    );
                                  })}
                           
                            </div>
                            )
                          }
                            <h3>javascript</h3>
                        </div>
                        <div className="box">
                        {isLoading 
                          ? 
                          <div className="image">
                          
                            <img src={Loading} alt="img"/>
                          </div>
                          : (
                                
                            <div>
                            {Object.keys(contactObjects).map((key) => {
                                return (
                                      <img src={contactObjects[key].icon4} alt=""/>
                                    );
                                  })}
                           
                            </div>
                            )
                          }
                            <h3>sass</h3>
                        </div>
                        <div className="box">
                        {isLoading 
                          ? 
                          <div className="image">
                          
                            <img src={Loading} alt="img"/>
                          </div>
                          : (
                                
                            <div>
                            {Object.keys(contactObjects).map((key) => {
                                return (
                                      <img src={contactObjects[key].icon5} alt=""/>
                                    );
                                  })}
                           
                            </div>
                            )
                          }
                            <h3>jquery</h3>
                        </div>
                        <div className="box">
                        {isLoading 
                          ? 
                          <div className="image">
                          
                            <img src={Loading} alt="img"/>
                          </div>
                          : (
                                
                            <div>
                            {Object.keys(contactObjects).map((key) => {
                                return (
                                      <img src={contactObjects[key].icon6} alt=""/>
                                    );
                                  })}
                           
                            </div>
                            )
                          }
                            <h3>react.js</h3>
                        </div>

                        <div className="box">
                        {isLoading 
                          ? 
                          <div className="image">
                          
                            <img src={Loading} alt="img"/>
                          </div>
                          : (
                                
                            <div>
                            {Object.keys(contactObjects).map((key) => {
                                return (
                                      <img src={contactObjects[key].cisco} alt=""/>
                                    );
                                  })}
                           
                            </div>
                            )
                          }
                            <h3>Cisco</h3>
                        </div>

                        <div className="box">
                        {isLoading 
                          ? 
                          <div className="image">
                          
                            <img src={Loading} alt="img"/>
                          </div>
                          : (
                                
                            <div>
                            {Object.keys(contactObjects).map((key) => {
                                return (
                                      <img src={contactObjects[key].bootstrap} alt=""/>
                                    );
                                  })}
                           
                            </div>
                            )
                          }
                            <h3> Bootstrap</h3>
                        </div>

                        <div className="box">
                        {isLoading 
                          ? 
                          <div className="image">
                          
                            <img src={Loading} alt="img"/>
                          </div>
                          : (
                                
                            <div>
                            {Object.keys(contactObjects).map((key) => {
                                return (
                                      <img src={contactObjects[key].rest} alt=""/>
                                    );
                                  })}
                           
                            </div>
                            )
                          }
                            <h3> Api Rest</h3>
                        </div>

                        <div className="box">
                        {isLoading 
                          ? 
                          <div className="image">
                          
                            <img src={Loading} alt="img"/>
                          </div>
                          : (
                                
                            <div>
                            {Object.keys(contactObjects).map((key) => {
                                return (
                                      <img src={contactObjects[key].ubiquiti} alt=""/>
                                    );
                                  })}
                           
                            </div>
                            )
                          }
                            <h3>Ubiquiti</h3>
                        </div>


                    </div>

                </section>



                <section className="education">

                    <h1 className="heading"> <span>FORMAÇÃO </span>ACADÊMICA</h1>

                    <div className="box-container">

                        <div className="box">
                            <i className="fas fa-graduation-cap"></i>
                            <span>2009 - 2012  Caracas- Venezuela</span>
                            <h3>TÉCNICO SUPERIOR</h3>
                            <p>Adquiriu atitudes empreendedoras e habilidades com treinamento abrangente para fornecer soluções eficazes para problemas relacionados à concepção, produção e implementação de aplicações e sistemas</p>
                         {/*  <p>Adquirí actitudes y destrezas de emprendedor con una formación integral para brindar soluciones efectivas a problemas relacionados con el diseño, producción e implantación de aplicaciones y sistemas </p> 
                         */} 
                        </div>

                        <div className="box">
                            <i className="fas fa-graduation-cap"></i>
                            <span>2015 - 2017 Caracas- Venezuela</span>
                            <h3>engenheiro de computação</h3>
                            <p>Aprendi a capacidade de analisar, projetar, desenvolver, implementar e gerenciar projetos de TI propondo novas soluções tecnológicas, integrando e adaptando sistemas existentes</p>
                            {/*<p>Adquirí la capacidad de analizar, diseñar, desarrollar, implementar y gestionar proyectos informáticos proponiendo nuevas soluciones tecnológicas, integrando y adaptando sistemas existentes</p> */ }
                        </div>

                        <div className="box">
                            <i className="fas fa-graduation-cap"></i>
                            <span>2014 - 2015 Caracas- Venezuela</span>
                            <h3>Networks CCNA EXPLORATION</h3>
                            <p>Aprendi as habilidades necessárias.
                                para cumprir as responsabilidades de trabalho de técnicos, administradores e engenheiros de rede</p>
                           { /*  <p> Obtuve las capacidades necesarias
                                para cumplir con las responsabilidades laborales de técnicos, administradores e ingenieros de red</p>  */}
                        </div>

                        <div className="box">
                            <i className="fas fa-graduation-cap"></i>
                            <span>2017 Caracas- Venezuela</span>
                            <h3>Programação estruturada</h3>
                            <p>Adquiriu o conhecimento para criar componentes de software, aplicando técnicas estruturadas de programação utilizando os elementos fornecidos pelo ambiente de desenvolvimento utilizado</p>
                           {/*  <p>Adquirí el conocimiento para crear componentes software aplicando las técnicas de programación estructurada utilizando los elementos proporcionados por el entorno de desarrollo utilizado</p> */}
                        </div>

                        <div className="box">
                            <i className="fas fa-graduation-cap"></i>
                            <span>2017 Caracas- Venezuela</span>
                            <h3>Java SE Standard Edition </h3>
                            <p>Obtive conhecimentos básicos para estudar mais as peculiaridades da tecnologia que engloba Java SE</p>
                          {/* <p>Obtuve conocimientos básicos para estudiar mas las peculiaridades de la tecnología que engloba Java SE</p>  */}
                        </div>

                        <div className="box">
                            <i className="fas fa-graduation-cap"></i>
                            <span>2017 Caracas- Venezuela</span>
                            <h3>Java EE Enterprise Edition</h3>
                            <p>Obtive as habilidades necessárias para desenvolver e executar uma variedade de aplicações web com tomcat, integrando código java (jsp) com html</p>
                          {/*  <p>Adquirí las destrezas necesaria para desarrollar y ejecutar una variedad de aplicaciones web con tomcat, integrando el código java (jsp) con html</p> */}
                        </div>

                    </div>

                </section>
            </div>

     </Bounce>



        </>

    );
};

export default About;
